import FaqPage from "~/components/Faq/FaqPage";

const HowWeWork = () => {
  return (
    <FaqPage
      selected={"how-we-work"}
      description={
        "A list of Frequently Asked Questions (FAQs) from our users about how RealEstateAgents.com works."
      }
    />
  );
};

export default HowWeWork;
